import { Component, Inject, Renderer2, RendererFactory2, TemplateRef } from "@angular/core";
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { isNullOrUndefined } from "../../utils";

export interface LoadingModalDialogData {
  title?: string;
  titleIcon?: string;
  message?: string;
};

@Component({
  templateUrl: 'loading-modal.dialog.html',
  standalone: false
})
export class LoadingModalDialog {
  title: string;
  titleIcon: string;
  message: string;

  constructor(
    public dialogRef: MatDialogRef<LoadingModalDialog>,
    @Inject(MAT_DIALOG_DATA) public data: LoadingModalDialogData) {
    this.title = this.data.title ?? 'Alert';
    this.titleIcon = this.data.titleIcon;
    this.message = this.data.message;
  }
}
